import {
  createContext,
  useContext,
  useState,
  Dispatch,
  SetStateAction,
  ReactNode,
  RefObject,
} from 'react'
import { ReactZoomPanPinchRef } from 'react-zoom-pan-pinch'

type ImageZoomPanCenterContextValue = {
  centeredScaleState: [number, Dispatch<SetStateAction<number>>]
  centeredPositionXState: [number, Dispatch<SetStateAction<number>>]
  onCenterZoomPan: () => void
}

type ImageZoomPanCenterProviderProps = {
  children: ReactNode
  transformerRef: RefObject<ReactZoomPanPinchRef | null>
}

const ImageZoomPanCenterContext = createContext<ImageZoomPanCenterContextValue>(
  [] as unknown as ImageZoomPanCenterContextValue,
)

export const useImageZoomPanCenterContext = () =>
  useContext(ImageZoomPanCenterContext)

export default function ImageZoomPanCenterProvider({
  children,
  transformerRef,
}: ImageZoomPanCenterProviderProps) {
  const centeredScaleState = useState(1)
  const centeredPositionXState = useState(0)

  function onCenterZoomPan() {
    transformerRef.current?.setTransform(
      centeredPositionXState[0],
      0,
      centeredScaleState[0],
    )
  }

  return (
    <ImageZoomPanCenterContext.Provider
      value={{
        centeredScaleState,
        centeredPositionXState,
        onCenterZoomPan,
      }}
    >
      {children}
    </ImageZoomPanCenterContext.Provider>
  )
}
